/**
 * PostHog Feature Flags
 * Centralized definitions for all feature flags used across the application
 */
export const FEATURE_FLAGS = {
    PSCC_CONNECT_LAUNCH: 'pscc-connect-launch',
} as const;
